export const MuiListItemAvatarTheme = () => {
    return {
        styleOverrides: {
            root: {
                minWidth: "unset",
            },
        },
    };
};
